import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserFromOAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUserFromOAuth(data);
        // strip hash
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/dashboard");
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, location.hash, setUserFromOAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="text-[11px] tracking-[0.32em] font-bold" style={{ color: "#A68A64", lineHeight: 1.05 }}>SUBTEND</div>
        <div className="text-[11px] tracking-[0.32em] font-bold text-foreground mt-1" style={{ lineHeight: 1.05 }}>STUDIO</div>
        <div className="font-serif text-3xl mt-6">Signing you in...</div>
      </div>
    </div>
  );
}
